
import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { CommentThreadComponent, ReportComment } from './comment-thread/comment-thread.component';
import { NgxPrintModule } from 'ngx-print';
import { tdf,makeI, makeII, makeIII, revenue,idex ,oc } from '../reportrowData';
import { ViewFromComponent } from '../viewFromComponent';

type FieldType = 'text' | 'number' | 'date' | 'html' | 'list' | 'unknown';

interface ReportField {
  key: string;
  label: string;
  type: FieldType;
  value: any;
}

interface ReportStep {
  stepId: number;
  stepCode: string;
  stepName: string;
  sequence: number;
  status: {
    is_present: boolean;
    is_final: boolean | null;
    is_draft: boolean | null;
    // workflow_status: any;
    // submitted_on: string | null;
  };
  fields: ReportField[];
  comments: { count: number; threads: ReportComment[] };
  rawData: any;
}

interface ReportModel {
  proposal: any;
  steps: ReportStep[];
}

const NULL_LIKE = new Set(['null', 'undefined', '']);

const STEP_SECTIONS: Record<string, { title: string; keys: string[] }[]> = {
  // Example mappings (add more as you need)
  'R-ND': [
    { title: 'Basic Details', keys: ['nomenclature', 'platform', 'consignee', 'mode_tendor'] },
    { title: 'Cost & Quantity', keys: ['development_cost', 'unit_cost', 'qty_req', 'prototype_qty', 'bulk_qty', 'poev', 'amount'] },
    { title: 'Technical / Justification', keys: ['technical_details', 'justification'] },
  ],
  'R-BM': [
    { title: 'Benchmarking', keys: ['base_price', 'bid_opening_date', 'bid_opening_time', 'justification'] },
  ],
  'R-PSO': [
    { title: 'Sanction Order', keys: ['financial_concurrence', 'cfa_approval', 'sanction_order', 'contract_conclusion', 'cnc_report', 'vendor'] },
  ],
};

@Component({
  selector: 'app-report',
  standalone: true,
  imports: [CommonModule, CommentThreadComponent, NgxPrintModule, DatePipe,ViewFromComponent],
  templateUrl: './report.component.html',
})
export class ReportComponent implements OnInit {
  @Input() apiResponse: any;
  @Input() schemeType: string;
  key:any;

  // report: ReportModel | null = null;

  // constructor(private sanitizer: DomSanitizer) {}

  // ngOnChanges(): void {
   
  //   if (this.apiResponse) {
  //     this.report = this.buildReportModel(this.apiResponse);
  //   } else {
  //     this.report = null;
  //   }
  // }

  ngOnInit(){
    switch(this.schemeType ){
      case 'revenue': this.key = revenue; break;
      case 'tdf' : this.key = tdf; break;
      case 'idex' : this.key = idex; break;
      case 'oc' : this.key = oc; break;
      case 'makeI' : this.key = makeI; break;
      case 'makeII' : this.key = makeII; break;
      case 'makeIII' : this.key = makeIII; break;

      default: this.key = revenue; break;
    }
    console.log("schemetype is ", this.schemeType);
   
  }

  // // ---------- Sanitization ----------
  // private cleanValue(v: any) {
  //   if (v === null || v === undefined) return null;
  //   if (typeof v === 'string' && NULL_LIKE.has(v.trim())) return null;
  //   return v;
  // }

  // private toTitle(key: string): string {
  //   return key
  //     .replaceAll('_', ' ')
  //     .replace(/\b\w/g, (m) => m.toUpperCase());
  // }

  // private inferType(key: string, value: any): FieldType {
  //   if (value == null) return 'unknown';

  //   if (typeof value === 'number') return 'number';

  //   if (typeof value === 'string') {
  //     const k = key.toLowerCase();
  //     if (k.includes('date') || k.endsWith('_on')) return 'date';
  //     if (value.trim().startsWith('<')) return 'html';
  //     if (!isNaN(Number(value)) && value.trim() !== '') return 'number';
  //     return 'text';
  //   }

  //   if (Array.isArray(value)) return 'list';

  //   return 'unknown';
  // }

  // safeHtml(html: string | null): SafeHtml {
  //   return this.sanitizer.bypassSecurityTrustHtml(html || '');
  // }

  // // ---------- Comments ----------
  // /** Normalize author object across varying API shapes */
  // private resolveAuthor(c: any) {
  //   return c?.created_by || c?.user || c?.comment?.user || c?.createdBy || null;
  // }

  // private normalizeComment(c: any): ReportComment {
  //   const raw = this.cleanValue(c?.comment);
  //   const isHtml = typeof raw === 'string' && raw.trim().startsWith('<');

  //   return {
  //     id: c.id,
  //     code: c.code,
  //     created_on: c.created_on || c.created_at,
  //     is_main: !!c.is_main,
  //     created_by: this.resolveAuthor(c),
  //     content: { type: isHtml ? 'html' : 'text', value: raw },
  //     replies: (c.replies || []).map((x: any) => this.normalizeComment(x)),
  //   };
  // }

  // /** Deduplicate comment tree by ID (your sample has same comment appearing twice) */
  // private dedupeComments(threads: ReportComment[]): ReportComment[] {
  //   const seen = new Set<number>();

  //   const walk = (node: ReportComment): ReportComment | null => {
  //     if (seen.has(node.id)) return null;
  //     seen.add(node.id);

  //     node.replies = (node.replies || [])
  //       .map(walk)
  //       .filter(Boolean) as ReportComment[];

  //     return node;
  //   };

  //   return threads.map(walk).filter(Boolean) as ReportComment[];
  // }

  // // ---------- Fields ----------
  // private buildFields(stepData: any): ReportField[] {
  //   if (!stepData) return [];

  //   const skip = new Set([
  //     'id',
  //     'code',
  //     'proposal_step',
  //   ]);

  //   const fields: ReportField[] = [];

  //   Object.keys(stepData).forEach((key) => {
  //     if (skip.has(key)) return;

  //     const raw = stepData[key];
  //     const value = this.cleanValue(raw);
  //     const type = this.inferType(key, value);

  //     fields.push({
  //       key,
  //       label: this.toTitle(key),
  //       type,
  //       value,
  //     });
  //   });

  //   // Keep stable order (optional): put unknown at end
  //   fields.sort((a, b) => (a.type === 'unknown' ? 1 : 0) - (b.type === 'unknown' ? 1 : 0));
  //   return fields;
  // }

  // // ---------- Report Model ----------
  // private buildReportModel(api: any): ReportModel {
  //   const proposal = api?.proposal || {};

  //   const steps: ReportStep[] = (api?.steps || []).map((s: any, idx: number) => {
  //     const stepData = s?.data ?? null;
  //     const fields = this.buildFields(stepData);

  //     const commentThreads = this.dedupeComments((s?.comments || []).map((c: any) => this.normalizeComment(c)));

  //     return {
  //       stepId: s.step_id,
  //       stepCode: s.step_code,
  //       stepName: s.step_name,
  //       sequence: idx + 1,
  //       rawData: stepData,
  //       status: {
  //         is_present: !!stepData,
  //         is_final: this.cleanValue(stepData?.is_final) ?? null,
  //         is_draft: this.cleanValue(stepData?.is_draft) ?? null,
  //         workflow_status: this.cleanValue(stepData?.status) ?? null,
  //         submitted_on: this.cleanValue(stepData?.submitted_on) ?? null,
  //       },
  //       fields,
  //       comments: {
  //         count: commentThreads.length,
  //         threads: commentThreads,
  //       },
  //     };
  //   });

  //   return { proposal, steps };
  // }

  // // ---------- Sections (config-driven) ----------
  // getSections(step: ReportStep): { title: string; fields: ReportField[] }[] {
  //   const EXCLUDE_KEYS = new Set([
  //     'status',
  //     'created_ip',
  //     'modified_ip',
  //     'modified_by',
  //     'created_on',
  //     'modified_on',
  //     'css_file_path',
  //     'created_by',
  //     'duplicated',
  //     'is_draft',
  //     'isfinal',
  //     'is_final',
  //     'isdraft',
  //     'isfinal',
  //   ]);

  //   const fieldsToShow = (step.fields ?? []).filter(
  //     (f) => f?.key && !EXCLUDE_KEYS.has(String(f.key).toLowerCase())
  //   );

  //   // Always return a single group for the step
  //   return [{ title: 'Details', fields: fieldsToShow }];
  // }
  

  // // ---------- Helpers for rendering ----------
  // isEmptyValue(v: any): boolean {
  //   if (v === null || v === undefined) return true;
  //   if (typeof v === 'string' && v.trim() === '') return true;
  //   if (Array.isArray(v) && v.length === 0) return true;
  //   return false;
  // }

  // asNumber(v: any): number | null {
  //   const cleaned = this.cleanValue(v);
  //   if (cleaned === null) return null;
  //   const n = Number(cleaned);
  //   return isNaN(n) ? null : n;
  // }

  
}















  